export default __webpack_public_path__ + "static/media/sync.736a1680.svg";